//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parse } from 'node-html-parser'

export default {
  async asyncData ({ store, route, $sentry, res }) {
    try {
      const story = await store.dispatch('story/GET', route.params.slug || route.meta.map(meta => meta.slug).pop())
      return { story }
    } catch (e) {
      $sentry.captureException(e)
      if (process.server) res.statusCode = 503
      throw new Error('Unable to load story')
    }
  },
  head () {
    this.$log.debug('head', 'HEAD')
    return {
      title: this.getEnglishTitle(this.story.title),
      meta: [
        ...this.getEnglishDescription(this.truncString(this.story.desc, 170)),
        { hid: 'og:title', property: 'og:title', content: this.getTitle(this.story.title) },
        { hid: 'og:image', property: 'og:image', content: this.story.header_img || this.story.cover_img }
      ]
    }
  },
  computed: {
    slug () {
      return this.$route.params.slug || this.$route.meta.slug
    },
    category () {
      return this.$route.params.category || this.$route.meta.category
    },
    blocks () {
      const root = parse(this.story.content)
      return root.childNodes.filter(block => block.rawTagName !== 'script')
    },
    url () {
      return `https://www.sungod.co/explore/${this.category}/${this.slug}`
    },
    urlEncoded () {
      return encodeURI(this.url)
    },
    emailSubject () {
      return `SunGod Stories: ${this.story.title}`
    },
    emailBody () {
      return `${this.story.desc}%0D%0A%0D%0ARead the latest SunGod Story here 👉 ${this.url}`
    },
    products () {
      return (this.story.featured_products || '').split(',').filter(product => product)
    },
    schema () {
      return {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        headline: this.story.title,
        image: [this.story.cover_img, this.story.header_img],
        datePublished: `${this.story.date}T00:00:00+00:00`,
        dateModified: `${this.story.date}T00:00:00+00:00`
      }
    }
  },
  mounted () {
    // Track that we've seen this story
    this.$store.dispatch('session/TRACK', { event: 'VIEW_STORY', body: this.slug })
  }
}
